import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  ButtonGroup,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Table,
} from "react-bootstrap";
import Sidebar from "../../Components/base/sidebar";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { BsEye, BsPencilSquare, BsTrash, BsTrashFill } from "react-icons/bs";
import CreateNew from "../../Components/Button/CreateNew";
import CurrentLatestNewsMediaTable from "../../Components/Tables/CurrentLatestNewsMediaTable";

interface Item {
  id: number;
  ticket_group_code: string;
  // Add more properties as per your item structure
}

export default function ViewNewsMedia() {
  const [items, setItems] = useState<Item[]>([]);
  const navigate = useNavigate();
  const isMounted = useRef(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const authToken = localStorage.getItem("authToken");
        console.log("Fetching data..."); // Debug log
        const response = await axios.get(
          "https://cdn.pulp.ph/api/v1/pulpliveworld/news-media",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        console.log("API Response:", response.data); // Debug log
        setItems(response.data.NewsMedia);
      } catch (error) {
        console.error("Error fetching data:", error); // Debug log
      }
    };

    fetchData();
  }, []);

  const handleDelete = async (id: number) => {
    try {
      const authToken = localStorage.getItem("authToken");
      if (!authToken) {
        alert("Authentication token not found!");
        return;
      }

      const confirmDelete = window.confirm(
        "Are you sure you want to delete this content?"
      );
      if (!confirmDelete) {
        return;
      }

      await axios.delete(
        `https://cdn.pulp.ph/api/v1/pulpliveworld/news-media/${id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );
      alert("Content Deleted Successfully !!");
      window.location.reload();
    } catch (error) {
      console.error("There was an error submitting the form!", error);
    }
  };

  const handleEdit = (id: number) => {
    console.log("Navigating to edit page with ID:", id); // Debug log
    navigate("/update/news-media/", { state: { id } }); // Pass the id through state
  };

  console.log("data:", items);

  return (
    <React.Fragment>
      <div className="w-full">
        <div className="Dashboard-container flex place-content-between">
          <h2 className="mt-5 font-semibold">List of News & Media</h2>
          <CreateNew />
        </div>

        {/* <div className="container mt-5">
                    <h3 className='font-semibold mb-1'>Pending Community Post</h3>
                    <CurrentDraftsTable
                        items={items}
                        onView={handleViewCommunity}
                        onEdit={handleEditCommunity}
                        onDelete={handleDelete}
                    />
                </div> */}

        {/* <CurrentApprovalsTable 
                        items ={items}
                        onView={handleViewShortstory}
                        onDelete={handleDelete}
                        /> */}

        <div className="container mt-5">
          <h3 className="font-semibold mb-1">All News & Media</h3>
          <CurrentLatestNewsMediaTable
            items={items as any}
            onDelete={handleDelete}
            onEdit={handleEdit} // Pass the updated handleEdit function
          />
        </div>
      </div>
    </React.Fragment>
  );
}
